import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrderSummaryItem  {
    _originalTypeClassName = "ekylikeio.BO.OrderSummaryItem";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrderSummaryItem.translate = translateService;
}
this.Id = null;
this.Name = null;
this.Count = null;
this.OrderSummaryItemKey = null;
this._key = this.OrderSummaryItemKey = 0; 
}

static translate: TranslateService;
_key: any;
Id:any;
Name:any;
Count:any;
private _OrderSummaryItemKey:any;
get OrderSummaryItemKey(): any {
    return this._OrderSummaryItemKey;
  }
set OrderSummaryItemKey(value: any) {
    this._OrderSummaryItemKey = value;
    this._key = value;
  }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.OrderSummaryItemKey == null || $this.OrderSummaryItemKey == 0;
            }


}